"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.number.constructor");
var _Vermicelli = require("@/api/member/Vermicelli");
var _member = require("@/api/member/member");
var _AcquisitionTime = require("@/utils/AcquisitionTime");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  props: {
    memberId: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      value1: [],
      statusTypeDataIndex: 1,
      sort: {
        orderBy: '',
        sortType: ''
      },
      statusTypeData: [{
        name: '今日',
        id: 1
      }, {
        name: '昨日',
        id: 2
      }, {
        name: '前天',
        id: 8
      }, {
        name: '近7天',
        id: 3
      }, {
        name: '近30天',
        id: 4
      }, {
        name: '近60天',
        id: 5
      }, {
        name: '近90天',
        id: 7
      }, {
        name: '自定义',
        id: 6
      }, {
        name: '全部',
        id: 0
      }],
      queryData: {
        fansType: '',
        effective: '',
        grade: '',
        phone: '',
        page: {
          page: 1,
          size: 10
        }
      },
      total: null,
      // 总条数
      options: [],
      tableData: [],
      checkList: ['头像', '用户昵称', '手机号码', '有效用户', '累计推广金', '累计自购金', '用户类型', '粉丝类型', '注册时间', '用户等级']
    };
  },
  watch: {
    $route: function $route(to, from) {
      console.log('to', to);
      // 对路由变化作出响应...
      this.queryFansListApi();
      this.memberQueryMemberGradeApi();
    }
  },
  mounted: function mounted() {
    // this.value1 = [null, null]
    this.value1 = [(0, _AcquisitionTime.weekDay)(0)[0], (0, _AcquisitionTime.weekDay)(0)[0].replace('00:00:00', '23:59:59')];
    this.queryFansListApi();
    this.memberQueryMemberGradeApi();
  },
  methods: {
    ObtainGetTime: function ObtainGetTime(num, num1) {
      return [this.$dayjs().subtract(num, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'), this.$dayjs().subtract(num1, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss')];
    },
    // onStatusList(data) {
    //   this.statusTypeDataIndex = data.id
    //   if (data.id === 1) {
    //     this.value1 = [weekDay(0)[0], weekDay(0)[0].replace('00:00:00', '23:59:59')]
    //   }
    //   if (data.id === 2) {
    //     this.value1 = [weekDay(1)[0], weekDay(1)[0].replace('00:00:00', '23:59:59')]
    //   }
    //   if (data.id === 3) {
    //     this.value1 = weekDay(7)
    //   }
    //   if (data.id === 4) {
    //     this.value1 = weekDay(30)
    //   }
    //   if (data.id === 5) {
    //     this.value1 = weekDay(60)
    //   }
    //   if (data.id === 7) {
    //     this.value1 = weekDay(90)
    //   }
    //   if (data.id === 8) {
    //     this.value1 = [weekDay(2)[0], weekDay(2)[0].replace('00:00:00', '23:59:59')]
    //   }
    //   if (data.id === 6) {
    //     this.value1 = []
    //     return false
    //   }
    //   this.queryData.page.page = 1
    //   this.queryFansListApi()
    // },
    onStatusList: function onStatusList(data) {
      this.statusTypeDataIndex = data.id;
      if (data.id === 0) {
        this.value1 = [];
      }
      if (data.id === 1) {
        this.value1 = this.ObtainGetTime(0, 0);
      }
      if (data.id === 2) {
        this.value1 = this.ObtainGetTime(1, 1);
      }
      if (data.id === 3) {
        this.value1 = this.ObtainGetTime(7, 0);
      }
      if (data.id === 4) {
        this.value1 = this.ObtainGetTime(30, 0);
      }
      if (data.id === 5) {
        this.value1 = this.ObtainGetTime(60, 0);
      }
      if (data.id === 7) {
        this.value1 = this.ObtainGetTime(90, 0);
      }
      if (data.id === 8) {
        this.value1 = this.ObtainGetTime(2, 2);
      }
      if (data.id === 6) {
        this.value1 = [];
        return false;
      }
      this.queryData.page.page = 1;
      this.queryFansListApi();
    },
    changeDataPicker: function changeDataPicker() {
      if (this.value1 === null) {
        this.value1 = [];
      }
      this.queryData.page.page = 1;
      this.queryFansListApi();
    },
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.queryFansListApi();
    },
    // 重置
    onReset: function onReset() {
      this.statusTypeDataIndex = 1;
      this.value1 = [null, null];
      this.queryData = {
        fansType: '',
        effective: '',
        grade: '',
        phone: '',
        page: {
          page: 1,
          size: 10
        }
      };
      this.queryFansListApi();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.queryFansListApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.queryFansListApi();
    },
    changePageLimit: function changePageLimit(value) {
      // 页码改变
      this.queryData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.queryData), value);
      console.log(value);
    },
    // 列表
    queryFansListApi: function () {
      var _queryFansListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({
                memberId: this.memberId,
                startTime: this.value1.length > 0 ? this.value1[0] : null,
                endTime: this.value1.length > 0 ? this.value1[1] : null
              }, this.queryData);
              _context.n = 1;
              return (0, _Vermicelli.queryFansListApi)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function queryFansListApi() {
        return _queryFansListApi2.apply(this, arguments);
      }
      return queryFansListApi;
    }(),
    memberQueryMemberGradeApi: function () {
      var _memberQueryMemberGradeApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {};
              _context2.n = 1;
              return (0, _member.memberQueryMemberGradeApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.options = res.data;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function memberQueryMemberGradeApi() {
        return _memberQueryMemberGradeApi2.apply(this, arguments);
      }
      return memberQueryMemberGradeApi;
    }(),
    onUserDetails: function onUserDetails(value) {
      this.$router.replace({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickname
        }
      });
      // this.$router.go({ path: '/member/userDetails', query: { memberId: value.memberId, nickname: value.nickname }})
    }
  }
};